import { BuilderComponent } from '@builder.io/react'

import { BlogHeroCarrossel } from '@/blocks/BlogHeroCarrossel'
import { SocialNetworksBlock, defaultSocialNetworks } from '@/blocks/SocialNetworks'
import { BUILDER_PAGE_MODEL } from '@/config/builder'

import { DEFAULT_ARTICLES_PER_PAGE } from '@/core/blog/constants'

import { AdsBottom } from '../AdsBottom'
import {
  LatestArticlesSection,
  MostViewedArticlesSection,
  OtherArticlesSection,
} from '../ArticleSections'
import type { BlogLayoutProps } from '../BlogLayout'

export function DefaultBlogLayout({
  content,
  adsBottom,
  latestArticles,
  mostViewedArticles,
  othersArticles,
}: BlogLayoutProps) {
  return (
    <>
      <BlogHeroCarrossel articles={latestArticles.slice(0, DEFAULT_ARTICLES_PER_PAGE)} />

      <MostViewedArticlesSection mostViewedArticles={mostViewedArticles} />
      <LatestArticlesSection latestArticles={latestArticles} />

      <BuilderComponent
        model={BUILDER_PAGE_MODEL}
        content={content}
        options={{ includeRefs: true }}
      />

      <AdsBottom adsBottom={adsBottom} />

      {othersArticles && <OtherArticlesSection othersArticles={othersArticles} />}

      <SocialNetworksBlock title="Acompanhe nossas redes sociais" items={defaultSocialNetworks} />
    </>
  )
}
